import { useState } from "react";
import type { CsvColumns } from "../lib/columnChoice";

/* Pick what goes in the file.
 *
 * Closed by default and showing the count, because the choice matters to the
 * person who wants it and should cost nothing to everyone else. The order
 * follows the order columns are ticked, so somebody who wants the phone number
 * first can have it first. */
export function ColumnChooser({ columns }: { columns: CsvColumns }) {
  const [open, setOpen] = useState(false);

  function toggle(name: string) {
    columns.set(
      columns.chosen.includes(name)
        ? columns.chosen.filter((c) => c !== name)
        : [...columns.chosen, name],
    );
  }

  return (
    <>
      <button onClick={() => setOpen((v) => !v)} aria-expanded={open}>
        Columns ({columns.chosen.length})
      </button>
      {open ? (
        <div className="panel-inline">
          <p className="muted" style={{ margin: "0 0 0.4rem" }}>
            These show in the table and go in the CSV. The CSV follows the order
            you tick them. The list is every field this screen's records have.
            {columns.isDefault ? "" : " Your choice is remembered on this computer."}
          </p>
          <div className="checks">
            {columns.all.map((name) => {
              const at = columns.chosen.indexOf(name);
              return (
                <label key={name} className="check">
                  <input
                    type="checkbox"
                    checked={at >= 0}
                    onChange={() => toggle(name)}
                  />
                  {name.replace(/_/g, " ")}
                  {at >= 0 ? <span className="muted"> {at + 1}</span> : null}
                </label>
              );
            })}
          </div>
          <div className="bar" style={{ marginTop: "0.5rem" }}>
            <button onClick={columns.reset} disabled={columns.isDefault}>
              Back to the usual columns
            </button>
            <button onClick={() => setOpen(false)}>Done</button>
          </div>
        </div>
      ) : null}
    </>
  );
}
